import React, { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';

import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpTabs from 'Wpds/components/tabs/WpTabs';
import WpTab from 'Wpds/components/tabs/WpTab';
import Commments from 'Shared/components/Comments/Comments';
import * as CommentsSelectors from 'Shared/selectors/Comments.selectors';
import { GoalItem } from 'Shared/constants/types';
import * as commentActions from 'Shared/actions/Comments.actions';
import GoalHistory from 'Shared/components/Goals/GoalHistory/GoalHistory';

import './GoalDetailsSidebar.scss';

type Props = {
  goal: GoalItem;
  isSidebarOpen: boolean;
  toggleSidbar: Function;
};

const GoalDetailsSidebar = ({ goal, isSidebarOpen, toggleSidbar }: Props) => {
  const TAB_COMMENTS = 'comments';
  const TAB_HISTORY = 'history';

  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState(TAB_COMMENTS);

  const { slug: goalSlug } = goal;

  const comments = useSelector(state => CommentsSelectors.getCommentsByGoalSlug(state, { goalSlug }))
    ?.valueSeq()
    .toJS();

  const handleCreateComment = useCallback(
    content => {
      const data = { goal_id: goalSlug, ...content };
      dispatch(commentActions.createComment(data));
    },
    [dispatch, commentActions, goalSlug]
  );

  const classes = classnames('GoalDetailsSidebar', isSidebarOpen ? 'GoalDetailsSidebar--open' : false);

  return (
    <div className={classes}>
      <div className="GoalDetailsSidebar__header">
        <div className="GoalDetailsSidebar__header__title">
          <h5>Activity</h5>
          <div className="GoalDetailsSidebar__header__close-btn">
            <WpButton variant="tertiary" onClick={() => toggleSidbar()}>
              <WpIcon name="times" />
            </WpButton>
          </div>
        </div>
        <div className="GoalDetailsSidebar__header__tabs">
          <WpTabs onTabClick={setActiveTab} activeTab={activeTab}>
            <WpTab tabId={TAB_COMMENTS}>Comments</WpTab>
            <WpTab tabId={TAB_HISTORY}>History</WpTab>
          </WpTabs>
        </div>
      </div>
      <div className="GoalDetailsSidebar__body">
        {activeTab === TAB_COMMENTS && (
          <Commments comments={comments} handleCreateComment={handleCreateComment} workspaceId={goal.workspaceSlug} />
        )}
        {activeTab === TAB_HISTORY && (
          <div className="GoalDetailsSidebar__history">
            <GoalHistory goal={goal} />
          </div>
        )}
      </div>
    </div>
  );
};

export default GoalDetailsSidebar;
